export default __webpack_public_path__ + "static/media/Snd_ClowerB.c219129c.mp3";